//Kilimambogo Projects 
import kilimambogo1 from "../images/coolbreeze/kilimambogo1.jpg";
import kilimambogo2 from "../images/coolbreeze/kilimambogo2.jpg";
import kilimambogo3 from "../images/coolbreeze/kilimambogo3.jpg";

//Kilimambogo Projects Phase 7
import phase6_1 from "../images/coolbreeze/phase6-1.jpeg";
import phase6_2 from "../images/coolbreeze/phase6-2.jpeg";
import phase6_3 from "../images/coolbreeze/phase6-3.jpeg";
import phase6_4 from "../images/coolbreeze/phase6-4.jpeg";
import phase6_5 from "../images/coolbreeze/phase6-5.jpeg";
import phase6_7 from "../images/coolbreeze/phase6-7.jpeg";   

// Malindi Projects
import malindi1 from "../images/imani/malindi1.jpg";
import malindi2 from "../images/imani/malindi2.jpg";


//Springview Project
import matuu1 from "../images/springview/matuu1.jpeg";
import matuu2 from "../images/springview/matuu2.JPG";
import matuu3 from "../images/springview/matuu3.JPG";
import matuu4 from "../images/springview/matuu4.JPG";
import matuu5 from "../images/springview/matuu16.jpeg";
import matuu6 from "../images/springview/matuu12.jpeg";
import matuu7 from "../images/springview/pricing.jpeg";



export const projects = [
    {
        id: 1,
        imageUrl1: kilimambogo1,
        imageUrl2: kilimambogo2,
        imageUrl3: kilimambogo3,
        imageUrl4: kilimambogo1,
        imageUrl5: kilimambogo2,
        imageUrl6: kilimambogo3,
        featuredImg: kilimambogo1,
        title: 'COOL BREEZE GARDENS KILIMAMBOGO',
        descriptionTitle : 'Invest in Cool Breeze Gardens – Kilimambogo!',
        youtubeUrl: '',
        paragraph1: 'Looking for an investment that merges natural beauty with strategic convenience? Cool Breeze Gardens, located in the breathtaking Kilimambogo region, offers 1/8 acre plots designed to elevate your lifestyle and future. With ready titles and an incredible price of KES 350,000 per plot, now is the time to secure your place in this thriving community!',
        whyTitle: 'Why Choose Cool Breeze Gardens?',
        reasons: [
            'Prime Location: Just 100 meters from the proposed tarmac road, providing quick access and boosting future value.',
            'Prime Location: Just 100 meters from the proposed tarmac road, providing quick access and boosting future value.',
            'Utilities in Place: Fully equipped with water and electricity connections, making it easy to start building your dream home or venture',
            'Fertile Land: The rich, arable soil is perfect for gardening and farming enthusiasts.',
            'Convenient Access to Essentials: Proximity to essential services, including schools, hospitals, and shopping centers like Kituluni.',
            'Year-Round Pleasant Climate: Enjoy a serene environment with favorable weather all year, perfect for relaxation and productivity',
            'Enhanced Accessibility: A new bypass is under construction from Tala to Garissa Road, making the location even more accessible.',
            'Nearby Attractions: Just minutes from Donyo Sabuk National Reserve and Fourteen Falls, offering endless exploration opportunities',
        ],
        pricingTitle : 'Pricing & Payment Options',
        pricing: 'KES 350,000 per 1/8 acre plot with flexible payment plans to fit your budget and investment goals.',
        siteVisit: 'Daily Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 350,000',
        size: '1/8th Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Kilimambogo',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Not Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Supply',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },

    {
        id: 2,
        imageUrl1: malindi1,
        imageUrl2: malindi2,
        imageUrl3: malindi1,
        imageUrl4: malindi2,
        imageUrl5: malindi1,
        imageUrl6: malindi2,
        featuredImg: malindi1,
        title: 'IMANI GARDENS MALINDI ACRES',
        descriptionTitle : 'An Acre Plots for Sale in Malindi',
        youtubeUrl: '',
        paragraph1: 'Agriculture is the backbone of our society. For this reason, a wise investment in it never goes wrong. This prime piece of land in Marereni, Malindi is fertile for Green grams, pineapples, macadamia nuts, mangoes, tree farming, goat farming, among others. It is on sale for only Kes 450,000 for an Acre.',
        whyTitle: 'Why Choose Imani Gardens?',
        reasons: [
            'Location: Marereni, 20 minutes drive from Malindi town.',
            'Proximity: 7 km from the Malindi-Lamu highway.',
            'Access: Well-paved roads for easy accessibility.',
            'Fertile Land: The rich, arable soil is perfect for gardening and farming enthusiasts.',
            'Utilities: Electricity and water available for both agricultural and livestock farming.',
            'Suitability: Ideal for both startup and experienced farmers.',
            'Investment Growth: Land value is appreciating due to the development of social amenities and infrastructure.',
            'Future Potential: Healthcare facilities and improved roads are being set up, increasing the investment appeal.',
        ],
        pricingTitle : 'Pricing & Payment Options',
        siteVisit: 'Book Site Visit',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 450,000',
        size: '1 Acre',
        propertyType: 'Land',
        landArea: 'Acre of Land',
        location: 'Malindi',
        propertyStatus: 'Available',
        status: 'Sold',
        type : 'Not Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Nearby',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },

    {
        id: 3,
        imageUrl1: malindi1,
        imageUrl2: malindi2,
        imageUrl3: malindi1,
        imageUrl4: malindi2,
        imageUrl5: malindi1,
        imageUrl6: malindi2,
        featuredImg: malindi1,
        title: 'FURAHA CITY MALINDI',
        descriptionTitle : 'Land for sale in Malindi Marereni',
        youtubeUrl: '',
        paragraph1: 'Agriculture is the backbone of our society. For this reason, a wise investment in it never goes wrong. This prime piece of land in Marereni, Malindi is fertile for Green grams, pineapples, macadamia nuts, mangoes, tree farming, goat farming, among others. It is on sale for only Kes 125,000 for 1/4 an Acre.',
        whyTitle: 'Why Choose Furaha City?',
        reasons: [
            'Location: Marereni, 20 minutes drive from Malindi town.',
            'Proximity: 7 km from the Malindi-Lamu highway.',
            'Access: Well-paved roads for easy accessibility.',
            'Fertile Land: The rich, arable soil is perfect for gardening and farming enthusiasts.',
            'Utilities: Electricity and water available for both agricultural and livestock farming.',
            'Suitability: Ideal for both startup and experienced farmers.',
            'Investment Growth: Land value is appreciating due to the development of social amenities and infrastructure.',
            'Future Potential: Healthcare facilities and improved roads are being set up, increasing the investment appeal.',
        ],
        pricingTitle : 'Pricing & Payment Options',
        siteVisit: 'Book Site Visit',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 150,000',
        size: '1/4 Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Malindi',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Nearby',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },

    {
        id: 4,
        imageUrl1: matuu1,
        imageUrl2: matuu2,
        imageUrl3: matuu3,
        imageUrl4: matuu4,
        imageUrl5: matuu5,
        imageUrl6: matuu6,
        featuredImg: matuu7,
        title: 'SPRINGVIEW GARDENS MATUU',
        descriptionTitle : 'INVEST IN MATUU – PRIME AGRICULTURAL LAND',
        youtubeUrl: '',
        paragraph1: 'Introducing Springview Gardens – a promising new land investment opportunity nestled just 10 minutes from Matuu Town along the Matuu-Kivadini bypass. This prime location boasts rich, fertile soils ideal for agriculture, making it perfect for both farming and future development. Own a 50 x 100 plot at an unbeatable cash offer of Ksh 265,000 and secure your place in a rapidly growing area with immense potential.',
        whyTitle: 'Why Choose Springview Gardens Matuu?',
        reasons: [
            'Strategic Location: Just 10 minutes from Matuu Town along the Matuu-Kivandini bypass, offering easy access and connectivity to key areas.',
            'Affordable Entry Point: Starting at just Ksh 265,000, it iss competitively priced compared to similar developments in the region.',
            'Flexible Payment Options: Pay in installments – Ksh 295,000 with only Ksh 100,000 deposit and balance spread over 3 months, making it accessible for many buyers',
            'Ready Title Deeds: Guarantees ownership security and quick transfer – no long waits or legal uncertainties',
            'High Agricultural Value: Fertile soils ideal for farming, making it perfect for agribusiness or food production.',
            'Future Growth Potential: Located in a fast-developing area, making it suitable for future residential or commercial development.',
            'Proximity to Infrastructure: Close to key social amenities and infrastructure, which continue to drive up land value.',
            'Proven Demand: Strong interest from other investors indicates trust and future returns on investment.',
        ],
        pricingTitle : 'Pricing & Payment Options',
        siteVisit: 'Book Site Visit',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 295,000',
        size: '1/8th Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Matuu',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Nearby',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },
    
     {
        id: 5,
        imageUrl1: phase6_3,
        imageUrl2: phase6_2,
        imageUrl3: phase6_1,
        imageUrl4: phase6_4,
        imageUrl5: phase6_5,
        imageUrl6: phase6_7,
        featuredImg: phase6_3,
        title: 'COOL BREEZE GARDENS PHASE 7 - KILIMAMBOGO',
        descriptionTitle : 'Invest in Cool Breeze Gardens – Kilimambogo!',
        youtubeUrl: phase6_7,
        paragraph1: 'Looking for an investment that merges natural beauty with strategic convenience? Cool Breeze Gardens, located in the breathtaking Kilimambogo region, offers 1/8 acre plots designed to elevate your lifestyle and future. With ready titles and an incredible price of KES 450,000 per plot, now is the time to secure your place in this thriving community!',
        whyTitle: 'Why Choose Cool Breeze Gardens?',
        reasons: [
            'Prime Location: Touching the proposed tarmac road, providing quick access and guaranteed future value.',
            'Utilities in Place: Fully equipped with water and electricity connections, making it easy to start building your dream home or venture',
            'Fertile Land: The rich, arable soil is perfect for gardening and farming enthusiasts.',
            'Convenient Access to Essentials: Proximity to essential services, including schools, hospitals, and shopping centers like Kituluni.',
            'Year-Round Pleasant Climate: Enjoy a serene environment with favorable weather all year, perfect for relaxation and productivity',
            'Nearby Attractions: Just minutes from Donyo Sabuk National Reserve and Fourteen Falls, offering endless exploration opportunities',
        ],
        pricingTitle : 'Pricing & Payment Options',
        pricing: 'KES 450,000 per 1/8 acre plot with flexible payment plans to fit your budget and investment goals.',
        siteVisit: 'Daily Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 450,000',
        size: '1/8th Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Kilimambogo',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Supply',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },

];